import dayjs from "dayjs";


type HBYCDetail = {
  hbyc: number;
  start: number;
  end: number;
};

type HBYCResult = {
  hbyc: number;
  startDate: string;
  endDate: string;
};

export const getOngoingHBYCDetails = (deliveryDate: string, visitDate:any): HBYCResult[] => {
    const HBYCDetails: HBYCDetail[] = [
      { hbyc: 1, start: 90, end: 179 },
      { hbyc: 2, start: 180, end: 269 },
      { hbyc: 3, start: 270, end: 359 },
      { hbyc: 4, start: 360, end: 463 },
  ];
   
    const delivery = dayjs(deliveryDate); // 01-01-2025 // date of birth
    const currentDate = dayjs(visitDate).isValid() ? dayjs(visitDate) : dayjs();// visit date // 07-04-2025
   
    const results = HBYCDetails.map(hbyc => {
        const startDate = delivery.add(hbyc.start, 'day').format('YYYY-MM-DD');
        const endDate = delivery.add(hbyc.end, 'day').format('YYYY-MM-DD');
        return {
          hbyc: hbyc.hbyc,
          startDate,
          endDate
      };
    });
   
    const ongoingHBYCDetails = results.filter(pnc => {
        const start = dayjs(pnc.startDate);
        const end = dayjs(pnc.endDate);
        return (currentDate.isAfter(start) || currentDate.isSame(start, 'day')) && (currentDate.isBefore(end) || currentDate.isSame(end, 'day'));
    });
    return ongoingHBYCDetails;
  };

  export const getHbycTitle = (hbycValue:any) => {
    switch (hbycValue) {
      case 1:
        return `Add Details/ HBYC ${hbycValue} (3 months)`;
      case 2:
        return `Add Details/ HBYC ${hbycValue} (6 months)`;
      case 3:
        return `Add Details/ HBYC ${hbycValue} (9 months)`;
      case 4:
        return `Add Details/ HBYC ${hbycValue} (12 months)`;
      default:
        return `Add Details/ HBYC ${hbycValue} (15 months)`;
    }
  };

  export const HBYC_API_DETAILS = {
    WEIGHT_IN_KEY: 'weight_in_kg',
    HEIGHT_IN_KEY: 'height_in_cm',
    WHETHER_CHILD_IS_SICK_KEY: 'whether_child_is_sick',
    WHETHER_EXCLUSIVE_BREASTFEEDING_CONTINUED_KEY: 'whether_exclusive_breastfeeding_continued',
    SYPHILIS_TEST_KEY: 'syphilis_test',
    RED_FLAG_SIGN_KEY: 'red_flag_sign',
    COLOR_ZONE: 'growth_zone_colour_code',
    GROWTH_CHART_MCP_CHART: 'growth_chart_of_mcp_card',
    WHETHER_CHILD_IS_REFERRED_KEY: 'whether_child_referred',
    HIV_TEST_KEY: 'hiv_screening_test',
    NACP_REFERRAL_FACILITY: 'referred_to_nacp_referral_facility',
    WHETHER_ORS_PROVIDED_KEY: 'whether_ors_provided',
    WHEATER_COMPLEMENTARY_FEEDING_STARTED_KEY: 'whether_complementary_feeding_started_at_6_months',
    WHEATER_COMPLEMENTARY_FEEDING_ADEQUATELY_PROVIDED_KEY: 'whether_complementary_feeding_adequately_provided',
    WHEATER_BOTTLE_OF_IFA_PROVIDED_KEY: 'whether_bottle_of_ifa_provided',
    WHEATER_CHILD_REFERRED:'whether_child_referred',
  };

  export const CHILD_DETAILS = {
    DATE_FORMATE: 'DD-MM-YYYY',
    EDIT_DETAILS_BTN: 'Edit Details',
    ADD_SERVICES_BTN: '+ Add Services',
    VIEW_MCP_CARD_BTN: 'View MCH Card',
    DOWNLOAD_HEALTH_PASSPORT_BTN: 'Download MCH Report',
    CANCEL:'Cancel',
    DOWNLOAD:'Download',
    MODAL_TITLE:'You have unsaved changes. Are you sure you want to leave without saving?',
    MODAL_CLOSE: 'Do you want to close the form?',
    BACK: 'back',
    HEADER_NAME:"HBYC",
    CREATE_CHILD_SUCCESS:'Child Hbyc Form has been created successfully',
    HBYC_SUCCESS_MSG: (isEdit: boolean) => {
      return isEdit ? "Child Hbyc Form has been updated successfully" : "Child Hbyc Form has been created successfully";
    },
  }

  export const hbycKey = {
    WEIGHT_OF_BABY: 'weightOfBaby',
    LENGTH_OF_BABY: 'lengthOfBaby',
    GROWTH_CHART_OF_MCP_CARD: 'growthChartOfMcpCard',
    RED_FLAG_SIGN: 'redFlagSign',
    WEATHER_CHILD_IS_SICK: 'weatherChildIsSick',
    WEATHER_CHILD_IS_REFERRED: 'weatherChildIsReffered',
    BREASTFEEDING_CONTINUE: 'breastfeedingContinue',
    SYPHILIS_TEST: 'syphilisTest',
    HIV_TEST: 'hivTest',
    NACP_REFERRAL_FACILITY: 'nacpRefferalFacility',
    WHETHER_BOTTLE_OF_IFA_PROVIDED: 'whetherBottleOfIfaProvided',
    WHETHER_ORS_PROVIDED: 'whetherOrsProvided',
    WHETHER_COMPLEMENTARY_FEEDING_STARTED_AT_6_MONTHS: 'whetherComplementaryFeedingStartedAt6months',
    WHETHER_COMPLEMENTARY_FEEDING_ADEQUATELY_PROVIDED: 'whetherComplementaryFeedingAdequatelyProvided',
    WHETHER_CHILD_IS_REFERRED: 'whetherChildIsReffered',
  }

  export const commonConstantHbycField = {
    NOT_DONE: 'Not Done',
  }

  export const childObj = {
    weightOfBaby: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    lengthOfBaby: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
    },
    growthChartOfMcpCard: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
    },
    redFlagSign: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    weatherChildIsSick: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
    weatherChildIsReffered: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
    breastfeedingContinue: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
   
  }

  export const hbyc4Obj = {
    hivTest: {
            isError: false,
            message: '',
            isDisable: false,
            value: false,
          },
          nacpRefferalFacility: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
          },
          whetherComplementaryFeedingAdequatelyProvided:{
            isError: false,
            message: '',
            isDisable: false,
            value: false,
          },
          whetherBottleOfIfaProvided: {
            isError: false,
            message: '',
            isDisable: false,
            value: false,
          },
          whetherOrsProvided:{
            isError: false,
            message: '',
            isDisable: false,
            value: false,
          }
  }
  export const childData = {
    weightOfBaby: {
      '#type': 'textfield',
      '#title': 'Weight of Baby (gms)',
      '#webform_key': 'weightOfBaby',
      '#required': true,
    },
    lengthOfBaby: {
      '#type': 'textfield',
      '#title': 'Length of Baby (cm)',
      '#webform_key': 'lengthOfBaby',
      '#required': true,
    },
    growthChartOfMcpCard: {
      '#type': 'select',
      '#title': 'Wheather child is in Green/Yellow/Red Zone of Growth chart of MCH card based on current visit vitals.',
      '#webform_key': 'growthChartOfMcpCard',
      '#isDisabled':true,
      '#required': true
    },
    redFlagSign: {
      '#type': 'select',
      '#title': 'Based on current visit vitals which "Red flag sign" of development issue identified',
      '#webform_key': 'redFlagSign',
      '#options': [],
      '#required': false,
      '#isDisabled':true,
      '#multiDropdown':true,
    },
    weatherChildIsSick: {
      '#type': 'select',
      '#title': 'Whether Child is Sick',
      '#webform_key': 'weatherChildIsSick',
      '#options': [],
      '#required': true,
      '#isDisabled':false,
      '#multiDropdown':true,
    },
    weatherChildIsReffered: {
      '#type': 'select',
      '#title': 'Whether Child Referred ?',
      '#webform_key': 'weatherChildIsReffered',
      '#options': [],
      '#isDisabled':true,
      '#required': true,
    },
    breastfeedingContinue: {
      '#type': 'select',
      '#title': 'Whether Exclusive Breastfeeding Continued ?',
      '#webform_key': 'breastfeedingContinue',
      '#options': [],
      '#required': true,
      '#isDisabled':false
    },
    
  }

  export const hbyc4Data = {
    whetherOrsProvided : {
            '#type': 'select',
            '#title': 'Whether ORS Provided',
            '#webform_key': 'whetherOrsProvided',
            '#options': [],
            '#isDisabled':false,
            '#required': true,
          },
          whetherComplementaryFeedingAdequatelyProvided : {
            '#type': 'select',
            '#title': 'Whether Complementary Feeding adequately provided ?',
            '#webform_key': 'whetherComplementaryFeedingAdequatelyProvided',
            '#options': [],
            '#isDisabled':false,
            '#required': true,
          },
          whetherBottleOfIfaProvided : {
            '#type': 'select',
            '#title': 'Whether Bottle of IFA provided ?',
            '#webform_key': 'whetherBottleOfIfaProvided',
            '#options': [],
            '#isDisabled':false,
            '#required': true,
          },
          hivTest: {
            '#type': 'select',
            '#title': 'HIV Test',
            '#webform_key': 'hivTest',
            '#options': [],
            '#isDisabled':false,
            '#required': true,
          },
          nacpRefferalFacility: {
            '#type': 'select',
            '#title': 'Referred to NACP referral facility',
            '#webform_key': 'nacpRefferalFacility',
            '#options': [],
            '#isDisabled':true,
            '#required': false,
          },
  }


  export const hbyc3Obj = {
    whetherComplementaryFeedingAdequatelyProvided:{
            isError: false,
            message: '',
            isDisable: false,
            value: false,
          },
          whetherBottleOfIfaProvided: {
            isError: false,
            message: '',
            isDisable: false,
            value: false,
          },
          whetherOrsProvided:{
            isError: false,
            message: '',
            isDisable: false,
            value: false,
          }
  }

  export const hbyc3Data = {
    whetherComplementaryFeedingAdequatelyProvided : {
            '#type': 'select',
            '#title': 'Whether Complementary Feeding adequately provided ?',
            '#webform_key': 'whetherComplementaryFeedingAdequatelyProvided',
            '#options': [],
            '#isDisabled':false,
            '#required': true,
          },
          whetherBottleOfIfaProvided : {
            '#type': 'select',
            '#title': 'Whether Bottle of IFA provided ?',
            '#webform_key': 'whetherBottleOfIfaProvided',
            '#options': [],
            '#isDisabled':false,
            '#required': true,
          },
          whetherOrsProvided: {
            '#type': 'select',
            '#title': 'Whether ORS Provided',
            '#webform_key': 'whetherOrsProvided',
            '#options': [],
            '#isDisabled':false,
            '#required': true,
          }
  }

  export const hbyc2Obj = {
    syphilisTest: {
            isError: false,
            message: '',
            isDisable: false,
            value: false,
          },
          hivTest: {
            isError: false,
            message: '',
            isDisable: false,
            value: false,
          },
          nacpRefferalFacility: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
          },
          whetherBottleOfIfaProvided: {
            isError: false,
            message: '',
            isDisable: false,
            value: false,
          },
          whetherOrsProvided:{
            isError: false,
            message: '',
            isDisable: false,
            value: false,
          },
          whetherComplementaryFeedingStartedAt6months:{
            isError: false,
            message: '',
            isDisable: false,
            value: false,
          },    
  }

  export const hbyc2Data = {
    syphilisTest: {
            '#type': 'select',
            '#title': 'Syphilis Test',
            '#webform_key': 'syphilisTest',
            '#options': [],
            '#isDisabled':false,
            '#required': true,
          },
          hivTest: {
            '#type': 'select',
            '#title': 'HIV Test',
            '#webform_key': 'hivTest',
            '#options': [],
            '#isDisabled':false,
            '#required': true,
          },
          nacpRefferalFacility: {
            '#type': 'select',
            '#title': 'Referred to NACP referral facility',
            '#webform_key': 'nacpRefferalFacility',
            '#options': [],
            '#isDisabled':true,
            '#required': false,
          },
          whetherOrsProvided : {
            '#type': 'select',
            '#title': 'Whether ORS Provided',
            '#webform_key': 'whetherOrsProvided',
            '#options': [],
            '#isDisabled':false,
            '#required': true,
          },
          whetherBottleOfIfaProvided : {
            '#type': 'select',
            '#title': 'Whether Bottle of IFA provided ?',
            '#webform_key': 'whetherBottleOfIfaProvided',
            '#options': [],
            '#isDisabled':false,
            '#required': true,
          },
          whetherComplementaryFeedingStartedAt6months : {
            '#type': 'select',
            '#title': 'Whether Complementary Feeding Started At 6 Months ?',
            '#webform_key': 'whetherComplementaryFeedingStartedAt6months',
            '#options': [],
            '#isDisabled':false,
            '#required': true,
          },
  }

  export const HBYC_TITLES: Record<number, string> = {
    1: "HBYC Details 1 (3 months)",
    2: "HBYC Details 2 (6 months)",
    3: "HBYC Details 3 (9 months)",
    4: "HBYC Details 4 (12 months)",
  };

  export const COMMON_HBYC_CONSTANTS = {
    HBYC_DETAILS: 'HBYC Details',
  }

  export const HBYC_DETAILS: Record<number, any> = {
    1: {
      ...childData,
      syphilisTest: {
        "#type": "select",
        "#title": "Syphilis Test",
        "#webform_key": "syphilisTest",
        "#options": [],
        "#isDisabled": false,
      },
      nacpRefferalFacility: {
        '#type': 'select',
        '#title': 'Referred to NACP referral facility',
        '#webform_key': 'nacpRefferalFacility',
        '#options': [],
        '#isDisabled':false,
      },
    },
    2: {
      ...childData,
      ...hbyc2Data,
    },
    3: {
      ...childData,
      ...hbyc3Data,
    },
    4: {
      ...childData,
      ...hbyc4Data,
    },
  };


  export const CHILD_OVERVIEW_LABELS = {
    IMMUNIZATION_HEADER:'Immunization',
    CHILD_DETAILS_HEADER: "Child Details",
    GUARDIAN_DETAILS_HEADER: "Guardian Details",
    SERVICE_PROVIDERS_HEADER: "Service Providers",
    FACILITY_DETAILS_HEADER: "Facility Details",
    NAME_OF_CHILD: "Name of Child",
    BAAL_ABHA_ID: "BAAL ABHA ID",
    PARENT_NAME: (parentLabel: string) => `${parentLabel}'s Name`,
    PARENT_ABHA_ID: (parentLabel: string) => `${parentLabel}'s ABHA ID`,
    PARENT_MOBILE_NUMBER: (parentLabel: string) => `${parentLabel}'s Mobile Number`,
    DATE_OF_BIRTH: "Date of Birth",
    MATURITY: "Maturity",
    GENDER: "Gender",
    WEIGHT_AT_BIRTH: "Weight at Birth(gms)",
    DATE_OF_REGISTRATION:"Date Of Registration",
    TIME_OF_REGISTRATION:"Time Of Registration",
    HEALTH_PROVIDER_NAME: "Health Provider Name",
    ASHA: "ASHA",
    FACILITY_TYPE: "Facility Type",
    FACILITY_NAME: "Facility Name",
    DEFAULT_FATHER_NAME: "Father's Name",
    DEFAULT_FATHER_MOBILE: "Father's Mobile Number",
    DEFAULT_MOTHER_NAME: "Mother's Name",
    DEFAULT_MOTHER_MOBILE: "Mother's Mobile Number",
    DEFAULT_GUARDIAN_NAME: "Guardian's Name",
    DEFAULT_GUARDIAN_MOBILE: "Guardian's Mobile Number",
  };

  export const CHILD_HEADER_LABELS = {
    FATHER_AND_GUARDIAN: "Father/ Guardian's Details",
    FATHER_AND_MOTHER: "Father/ Mother's Details",
    MOTHER_AND_GUARDIAN: "Mother/ Guardian's Details",
  };

  export const CHILD_NAVIGATION = {
    HBYC_FORM: '/beneficiaries/hbyc/service',
    NEW_BORN: '/beneficiaries/service/new-born',
    SICK_CHILD_CARE: '/beneficiaries/sick-child-care',
  }

  export const CHILD_COMMON_CONSTANTS = {
    CHILD_UPDATED_MESSAGE: 'Child Details updated successfully',
  }

  export const SYPHILIS_TEST_OPTIONS = {
    NOT_DONE: 'Not Done',
    REACTIVE: 'Reactive',
    NON_REACTIVE: 'Non Reactive'
  }
  
  export const IS_TESTED_FOR_HIV_OPTIONS = {
    REFERRED_TO_CONFIRMATORY_FACILITY: 'Referred to Confirmatory Facility',
    NOT_DONE: 'Not Done',
    NON_REACTIVE: 'Non-Reactive'
  }